import { Component, OnInit } from '@angular/core';
import { VacanciesService } from '../services/vacancies.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers : [VacanciesService]
})
export class NavbarComponent implements OnInit {
count ;
  constructor(private serviceVacancy: VacanciesService) { }

  ngOnInit() {
    this.count = this.serviceVacancy.getIndexVacancies() ;
console.log(this.count, 'count = index');
  }
}
